import React, { useEffect, useState } from "react";

import { getBenefitTarget } from "../../../extras";
// APP COMPONENTS
import BeautifiedOrderProductsJsonBody from "./BeautifiedOrderProductsJsonBody";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Slide } from "@mui/material";
import Typography from "@mui/material/Typography";
import { LightGreyBox } from "../../styled";
// ICONS
import WestIcon from "@mui/icons-material/West";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import { CustomModalRoot } from "../../styled/modal";
import { formatFinance } from "../../../utils/formatters";

const JsonModal = ({
  open,
  onClose,
  code,
  jsonBodyString,
  title,
  createdBy,
}) => {
  const [jsonBody, setJsonBody] = useState(null);
  const [jsonBodyContent, setJsonBodyContent] = useState(null);

  useEffect(() => {
    if (!jsonBodyString) {
      return;
    }

    setJsonBody(JSON.parse(jsonBodyString));
  }, [jsonBodyString]);

  const returnJsonBodyContent = () => {
    switch (code) {
      case "OPE":
        return (
          <BeautifiedOrderProductsJsonBody
            jsonBody={jsonBody}
            createdBy={createdBy}
          />
        );
      case "OBA":
        return (
          <LightGreyBox>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <LoyaltyIcon />
            </Box>
            <Typography variant="subtitle1" align="center">
              {getBenefitTarget(jsonBody.target)}
            </Typography>
            <Typography variant="subtitle1" align="center">
              {formatFinance(jsonBody.value ?? 0)}
            </Typography>
            <Typography variant="subtitle1" align="center">
              {createdBy}
            </Typography>
          </LightGreyBox>
        );

      default:
        return;
    }
  };

  const handleOnClose = (e) => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleOnClose}
      closeAfterTransition
      sx={{
        zIndex: 999999,
        border: "none",
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Slide in={open} direction="up" mountOnEnter unmountOnExit>
        <CustomModalRoot
          top={25}
          left={35}
          width={30}
          height={40}
          overflow={"auto"}
        >
          <Box>
            <Typography
              variant="h5"
              align="center"
              fontWeight="bold"
              sx={{ my: 3 }}
            >
              {title}
            </Typography>
            {jsonBody && returnJsonBodyContent()}
            <Button
              fullWidth
              variant="contained"
              color="info"
              aria-label="Voltar"
              startIcon={<WestIcon />}
              onClick={handleOnClose}
              sx={{ mt: 2 }}
            >
              Voltar
            </Button>
          </Box>
        </CustomModalRoot>
      </Slide>
    </Modal>
  );
};

export default JsonModal;
